/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fleets: NonNullable<unknown> }} Welcome_Phase_Rmf_LoadingInputs */

const en_welcome_phase_rmf_loading = /** @type {(inputs: Welcome_Phase_Rmf_LoadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registering fleets (${i?.fleets} ready)`)
};

const fr_welcome_phase_rmf_loading = /** @type {(inputs: Welcome_Phase_Rmf_LoadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enregistrement des flottes (${i?.fleets} prête(s))`)
};

const ms_sg2_welcome_phase_rmf_loading = /** @type {(inputs: Welcome_Phase_Rmf_LoadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mendaftarkan armada (${i?.fleets} sedia)`)
};

/**
* | output |
* | --- |
* | "Registering fleets ({fleets} ready)" |
*
* @param {Welcome_Phase_Rmf_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_phase_rmf_loading = /** @type {((inputs: Welcome_Phase_Rmf_LoadingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Phase_Rmf_LoadingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_phase_rmf_loading(inputs)
	if (locale === "fr") return fr_welcome_phase_rmf_loading(inputs)
	return ms_sg2_welcome_phase_rmf_loading(inputs)
});